/** @type {string} */
const collapseComponent = "Collapse";
export default collapseComponent;
